import React from 'react'
import ContractView from './ContractDetailsView'
import * as contractService from '../ContractsService'
import * as FlashMessage from '../../FlashMessage/FlashMessageConstants'

export default class Contract extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            modalVisible: false
        }
        this.handleModalDisplay = this.handleModalDisplay.bind(this)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.contractId !== this.props.contractId) {
            this.getContract(this.props.contractId)
        }
        if (!prevProps.apiClientLoaded && this.props.apiClientLoaded) {
            this.getContract(this.props.contractId)
        }
    }

    componentDidMount() {
        const {selectContract, apiClientLoaded, contractId, setPath, path} = this.props
        setPath(path)
        selectContract(null)
        if (apiClientLoaded) {
            this.getContract(contractId)
        }
    }

    render() {
        return <ContractView 
            contract={this.props.contract} 
            setContractAsCurrent={this.setContractAsCurrent}
            handleModalConfirmClick={this.handleModalConfirmClick}
            modalVisible={this.state.modalVisible}
            handleModalDisplay={this.handleModalDisplay}
            />
    }

    handleModalConfirmClick = (contractId) => {
        this.setContractAsCurrent(contractId)
    }

    handleModalDisplay = (modalVisible) => {
        this.setState({modalVisible})
    }

    getContract(contractId) {
        const { selectContract, setFlashMessage } = this.props
        return contractService.getContract(contractId)
            .then(contract => {
                selectContract(contract)
            })
            .catch(() => {
                setFlashMessage(FlashMessage.GetContractFailed)
            })
    }

    setContractAsCurrent = (contractId) => {
        const { selectContract, currentContractUpdated, contract, setFlashMessage } = this.props
        return contractService.setContractAsCurrent(contractId)
            .then(() => {
                let updatedContract = contract
                updatedContract.active = true
                selectContract(updatedContract)
                currentContractUpdated(true)
                this.setState({modalVisible: false})
                setFlashMessage(FlashMessage.ActivateContractSuccess)
            })
            .catch(() => {
                setFlashMessage(FlashMessage.ActivateContractFailed)
            })
    }
}


// WEBPACK FOOTER //
// ./src/components/Contracts/Details/ContractDetails.jsx